<template>
  <b-row>
    <b-col cols="1">
      <h5>#{{ (index + 1) }}</h5>
    </b-col>
    <b-col>
      <div class="form-group">
        <fg-input>
          <el-select
                  class="select-default"
                  :placeholder="$t('views.automats.servicemanitemspicking.position.idExsbItem')"
                  filterable
                  v-model="item.idExsbItem">
            <el-option v-for="option in itemsOptions"
                       class="select-default"
                       :value="option['@id']"
                       :label="option.name"
                       :key="option['@id']">
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </b-col>
    <b-col cols="2">
      <input
              v-model="item.quantity"
              class="form-control"
              min="1"
              type="number"
              :placeholder="$t('views.automats.servicemanitemspicking.position.quantity')">
    </b-col>
    <b-col cols="2">
      <b-btn class="m-0 w-100" @click="removePosition(index)" variant="danger">{{ $t('buttons.delete') }}</b-btn>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Position',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    removePosition: {
      type: Function,
      required: true
    },
    itemsOptions: {
      type: Array,
      require: true
    }
  }
}
</script>
